import { http } from "./config";
import authHeader from "./auth-header";

export default {
  importarVendas: (file, empresa, ano, mes) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empresa", empresa);
    formData.append("ano", ano);
    formData.append("mes", mes);

    // Primeiro obtemos os headers de autenticação
    const headers = authHeader();
    // Depois adicionamos o Content-Type específico para FormData
    headers["Content-Type"] = "multipart/form-data";

    return http.post("/comissao-dash/importar-vendas", formData, { headers });
  },

  excluirImportacao(id) {
    return http.delete(`/comissao-dash/excluir-importacao/${id}`, {
      headers: authHeader(),
    });
  },

  lista_venda_resumo: () => {
    return http.get("/comissao-dash/lista-importados/", {
      headers: authHeader(),
    });
  },

  lista_venda_itens: (id) => {
    return http.get(`/comissao-dash/lista-importados-itens/${id}`, {
      headers: authHeader(),
    });
  },

  lista_comissao: (dataI, dataF, nomeEmpresa, tipo, filtro, opcao, produto) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/comissao-dash/lista-comissao/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_regras: (dataF, nomeEmpresa) => {
    const params = {
      "data-final": dataF,
      empresa: nomeEmpresa,
    };

    return http.get("/comissao-dash/lista-regras/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_comissao_venda_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-venda-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },
  lista_comissao_venda_alelo_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-venda-alelo-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_ferias: (dataInicial, nomeEmpresa) => {
    const params = {
      "data-inicial": dataInicial,
      empresa: nomeEmpresa,
    };

    return http.get("/planilha-dash/lista-ferias", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_comissao_venda: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/comissao-dash/lista-comissao-venda/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_simulacao_venda: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo,
      filtro,
      opcao,
      produto,
    };

    return http.get("/simulacao-venda/listar", {
      params,
      headers: authHeader(),
    });
  },

  planilha_simulacao_venda: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo,
      filtro,
      opcao,
      produto,
    };

    return http.get("/simulacao-venda/planilha", {
      params,
      responseType: "blob",
      headers: authHeader(),
    });
  },

  lista_comissao_entregas: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/comissao-dash/lista-comissao-entregas/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_comissao_alelo_total: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-alelo-todos/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_comissao_entrega_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-entrega-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_comissao_entrega_alelo_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-entrega-alelo-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_comissao_funeraria: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/comissao-dash/lista-comissao-funeraria/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_vendedores: () => {
    return http.get("/comissao-dash/lista-vendedores/", {
      headers: authHeader(),
    });
  },

  lista_locais: () => {
    return http.get("/comissao-dash/lista-locais/", {
      headers: authHeader(),
    });
  },

  adiciona: (controle) => {
    return http.post("/comissao-dash/salvar/", controle, {
      headers: authHeader(),
    });
  },

  adiciona_conformidade: (controle) => {
    return http.post("/comissao-dash/salvar-conformidade/", controle, {
      headers: authHeader(),
    });
  },

  deletar: (id) => {
    return http.delete(`/comissao-dash/deletar/${id}`, {
      headers: authHeader(),
    });
  },

  deletar_conformidade: (id) => {
    return http.delete(`/comissao-dash/deletar-conformidade/${id}`, {
      headers: authHeader(),
    });
  },

  lista_controle: () => {
    return http.get("/comissao-dash/lista-controle/", {
      headers: authHeader(),
    });
  },

  lista_conformidade: () => {
    return http.get("/comissao-dash/lista-conformidade/", {
      headers: authHeader(),
    });
  },
  lista_conformidade_filtro: (periodo, modelo, empresa) => { // periodo = MM-AAAA
    return http.get("/comissao-dash/lista-conformidade/" + periodo + "/" + modelo, {
      params: {
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  lista_comissao_funeraria_total: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/comissao-dash/lista-comissao-funeraria-total/", {
      params: params,
      headers: authHeader(),
    });
  },

  lista_comissao_alelo_tudo_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-alelo-todos-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_comissao_alelo_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-alelo-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_comissao_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_comissao_funeraria_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-funeraria-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },

  lista_comissao_funeraria_alelo_xls: (
    dataI,
    dataF,
    nomeEmpresa,
    tipo,
    filtro,
    opcao,
    produto
  ) => {
    const params = {
      "data-inicial": dataI,
      "data-final": dataF,
      empresa: nomeEmpresa,
      tipo: tipo,
      filtro: filtro,
      opcao: opcao,
      produto: produto,
    };

    return http.get("/planilha-dash/lista-comissao-funeraria-alelo-xls", {
      params: params,
      responseType: "blob", // Configurar responseType como 'blob' para baixar um arquivo binário
      headers: authHeader(), // Certifique-se de incluir os cabeçalhos de autenticação aqui
    });
  },
  
  finalizarPeriodo: (empresa, dataInicio, dataFim, tipo) => {
    const params = {
      empresa: empresa,
      dataInicial: dataInicio,
      dataFinal: dataFim,
      tipo: tipo,
    };

    return http.post("/comissao-dash/finalizar-periodo", null, {
      params: params,
      headers: authHeader(),
    });
  },

  buscarLote: (competencia, tipo, empresa) => {
    const params = {
      competencia: competencia,
      tipo: tipo,
      empresa: empresa,
    };

    return http.get("/comissao-dash/buscar-lote", {
      params: params,
      headers: authHeader(),
    });
  },

  buscarLoteComItens: (competencia, tipo, empresa) => {
    const params = {
      competencia: competencia,
      empresa: empresa,
      tipo: tipo,
    };

    return http.get("/comissao-dash/buscar-lote-com-itens", {
      params: params,
      headers: authHeader(),
    });
  },

  buscarLoteIncluindoTodos: (competencia, tipo, empresa) => {
    const params = {
      competencia: competencia,
      tipo: tipo,
      empresa: empresa,
    };

    return http.get("/comissao-dash/buscar-lote-incluindo-todos", {
      params: params,
      headers: authHeader(),
    });
  },

  reabrirPeriodo: (competencia, tipo, empresa) => {
    const params = {
      competencia: competencia,
      tipo: tipo,
      empresa: empresa,
    };

    return http.post("/comissao-dash/reabrir-periodo", null, {
      params: params,
      headers: authHeader(),
    });
  },
};
